import { motion } from 'framer-motion';
import { useLanguage } from '../../lib/i18n/LanguageContext';
import SectionTitle from '../../components/ui/SectionTitle';
import AnimatedPhoneIcon from '../../components/ui/AnimatedPhoneIcon';
import AnimatedClockIcon from '../../components/ui/AnimatedClockIcon';
import AnimatedPinIcon from '../../components/ui/AnimatedPinIcon';
import AnimatedEmailIcon from '../../components/ui/AnimatedEmailIcon';

const ContactInfo = () => {
  const { t } = useLanguage();

  return (
    <motion.div
      initial={{ opacity: 0, x: -20 }}
      whileInView={{ opacity: 1, x: 0 }}
      viewport={{ once: true }}
      transition={{ duration: 0.6 }}
      className="space-y-8"
    >
      <SectionTitle title={t.contact.getInTouch.title} align="left" className="mb-10">
        <p className="text-neutral-700 mt-4">{t.contact.getInTouch.subtitle}</p>
      </SectionTitle>

      <div className="flex items-start gap-4">
        <div className="bg-red-100 p-3 rounded-full text-red-800 flex items-center justify-center">
          <AnimatedPinIcon size={24} />
        </div>
        <div>
          <h3 className="font-serif font-semibold text-lg text-neutral-900 mb-1">
            {t.contact.getInTouch.location}
          </h3>
          <p className="text-neutral-700 mb-1">Best Italian restaurant in downtown Reykjavik</p>
          <a
            href="https://maps.app.goo.gl/iJ38nHTkanTaXeiS8"
            target="_blank"
            rel="nofollow noopener noreferrer"
            className="text-neutral-700 hover:text-red-800 transition-colors"
          >
            Laugavegi 40a, 101 Reykjavík
          </a>
        </div>
      </div>

      <div className="flex items-start gap-4">
        <div className="bg-red-100 p-3 rounded-full text-red-800 flex items-center justify-center">
          <AnimatedPhoneIcon size={24} />
        </div>
        <div>
          <h3 className="font-serif font-semibold text-lg text-neutral-900 mb-1">
            {t.contact.getInTouch.phone}
          </h3>
          <a
            href="tel:+354-561-0500"
            data-umami-event="tel-click"
            data-umami-event-location="contact"
            className="text-neutral-700 hover:text-red-800 transition-colors"
          >
            561 0500
          </a>
        </div>
      </div>

      <div className="flex items-start gap-4">
        <div className="bg-red-100 p-3 rounded-full text-red-800 flex items-center justify-center">
          <AnimatedEmailIcon size={24} />
        </div>
        <div>
          <h3 className="font-serif font-semibold text-lg text-neutral-900 mb-1">
            {t.contact.getInTouch.email}
          </h3>
          <a
            href="mailto:larusg@simnet.is"
            data-umami-event="mailto-click"
            data-umami-event-location="contact"
            className="text-neutral-700 hover:text-red-800 transition-colors"
          >
            larusg@simnet.is
          </a>
        </div>
      </div>

      <div className="flex items-start gap-4">
        <div className="bg-red-100 p-3 rounded-full text-red-800 flex items-center justify-center">
          <AnimatedClockIcon size={24} />
        </div>
        <div>
          <h3 className="font-serif font-semibold text-lg text-neutral-900 mb-1">
            {t.contact.getInTouch.hours}
          </h3>
          <p className="text-neutral-700">{t.contact.getInTouch.hoursDetails.weekdays}</p>
          <p className="text-neutral-700">{t.contact.getInTouch.hoursDetails.sunday}</p>
        </div>
      </div>
    </motion.div>
  );
};

export default ContactInfo;
